import API from '@aws-amplify/api';
import { mcpServerGet } from '@/graphql/queries';
import { mcpServerUpdate } from '@/graphql/mutations';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

export const getMCPServer = async params => {
    try {
        let res = await API.graphql({
            query: mcpServerGet,
            variables: {
                params: {
                    ...params
                }
            }
        });
        return res.data.mcpServerGet;
    } catch (err) {
        console.log('getMCPServer error >>>', err);
        return { success: false };
    }
};

export const updateMCPServer = async requestDto => {
    try {
        let res = await API.graphql({
            query: mcpServerUpdate,
            variables: {
                mcpServerUpdateRequestDto: requestDto
            }
        });
        return res.data.mcpServerUpdate;
    } catch (err) {
        console.log('updateMCPServer error >>>', err);
        return null;
    }
};


export const getMcpServerByIdList = async (idList = []) => {
    if (Utils.isEmptyArray(idList)) return [];

    let response = await getMCPServer({
        getMethod: Constant.MCP_SERVER_GET_METHOD.GET_MCP_SERVER_BY_ID_LIST,
        idList: idList
    });

    let mcpList = [];
    if (response?.success) {
        const payload = Utils.convertJSONDataToObject(response.payload);
        if (!Utils.isEmptyArray(payload?.listItem)) {
            mcpList = payload?.listItem;
        }
    }

    return mcpList.filter(mcp => !Utils.isEmptyObject(mcp));
};

export const getMcpServerByOwnerBy = async (affiliationOrganization, ownerBy) => {
    //comment personal connector
    // if (!affiliationOrganization || !ownerBy) return [];
    // let response = await getMCPServer({
    //     getMethod: Constant.MCP_SERVER_GET_METHOD.GET_MCP_SERVER_BY_OWNER_BY,
    //     corporationInuse: affiliationOrganization,
    //     userId: ownerBy
    // });
    // let mcpList = [];
    // if (response?.success) {
    //     const payload = Utils.convertJSONDataToObject(response.payload);
    //     if (!Utils.isEmptyArray(payload)) {
    //         mcpList = payload;
    //     }
    // }

    // return mcpList.filter(mcp => !Utils.isEmptyObject(mcp));

    return []
};


export const getMcpServerListByProject = async (projectId, userId, corporationId) => {
    if (!projectId || !userId || !corporationId) return [];
    let response = await getMCPServer({
        corporationInuse: corporationId,
        projectInuse: projectId,
        getMethod: Constant.MCP_SERVER_GET_METHOD.GET_LIST_ACTIVE_MCP_BY_PROJECT,
        userId: userId
    });

    let mcpServerList = [];
    const payload = Utils.convertJSONDataToObject(response?.payload);
    if (response?.success && !Utils.isEmptyArray(payload?.listItem)) {
        mcpServerList = payload?.listItem;
    }

    return mcpServerList;
}